import Router from "next/router";
import React from "react";
import { clientFetch, url } from "../fetch-client/fetch_client";

class ErrorLogWrapper extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
			isRedirecting: false,
		};
	}
	// Catches client-side errors
	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidMount() {
		Router.events.on("routeChangeComplete", this.handleRouteChange);
	}

	componentWillUnmount() {
		Router.events.off("routeChangeComplete", this.handleRouteChange);
	}

	// Sets the redirect state and error state to false when the user is redirected to the 500 page
	handleRouteChange = () => {
		if (this.state.isRedirecting) {
			this.setState({
				hasError: false,
				isRedirecting: false,
			});
		}
	};

	componentDidCatch = async (error, errorInfo) => {
		// Log the client-side error
		try {
			const { status } = await clientFetch(url`/api/client-side/error`, {
				json: { errorInfo: errorInfo, message: error.message },
			}).post();
			// Redirect to 500 page when the response from the route is 500
			if (status === 500 && !this.state.isRedirecting) {
				this.setState({ isRedirecting: true }, () => {
					Router.push("/500");
				});
			}
		} catch {
			console.info("Could not log error.");
		}
	};

	componentDidUpdate() {
		if (this.state.hasError && !this.state.isRedirecting) {
			this.setState({ isRedirecting: true }, () => {
				Router.push("/500");
			});
			return null;
		}
	}

	render() {
		// Redirect to 500 page if a client-side error occurred and the redirecting state isn't true
		if (this.state.hasError && !this.state.isRedirecting) {
			return null;
		}
		return this.props.children;
	}
}

export default ErrorLogWrapper;
